// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","FilterForm__hgroup":"ok_a bgu_a bgu_x","FilterForm__vgroup":"ok_b bgu_rp"};